import { render, staticRenderFns } from "./SendRecordInfo.vue?vue&type=template&id=5fcdbccf&scoped=true"
import script from "./SendRecordInfo.vue?vue&type=script&lang=js"
export * from "./SendRecordInfo.vue?vue&type=script&lang=js"
import style0 from "./SendRecordInfo.vue?vue&type=style&index=0&id=5fcdbccf&prod&lang=scss&scoped=true"
import style1 from "./SendRecordInfo.vue?vue&type=style&index=1&id=5fcdbccf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcdbccf",
  null
  
)

export default component.exports